<div class="modal-body _pop-overlay _math-key-popup">
  <div class="mid-panel">
    <div class="_pop-mid-content _math-key-popup _newkey-added-main _outer-container" appModalFocusOnInit="100" tabindex="-1">
      <div class="_math-key-mid _newkey-added">
        <div class="_top-icon">
          <img src="assets/images/checkmark-01-5.svg" aria-hidden="true" />
        </div>
        <div class="heading">
          {{ 'moveFolderHeading' | translate }}
          <p>
            {{ (isExport ? 'moveFolderDescriptionOne' : 'moveFolderDescriptionTwo') | translate }}
          </p>
        </div>
        <div class="checkbox-popup">
          <form class="_form-section _redio-box _box-checkbox" [formGroup]="moveFolderForm">
            <!--form feild start-->
            <div class="form-field _move-items">
              <div class="_new-added _foldertick2">
                <img src="assets/images/not-done-icon.svg" [attr.alt]="'notDoneFolderAlt' | translate" />
              </div>
              <div
                class="form-group custom_radio _box-checkbox toggle_parent"
                appDynamicTabIndex
                tabindex="0"
                (keydown.enter)="setMoveFileToggled('1')"
              >
                <input type="radio" id="status-Notdone" name="status" formControlName="status" value="1" tabindex="-1" />
                <label for="status-Notdone" class="toggle_child"></label>
              </div>
              <div class="_terms">
                <p>
                  {{ 'moveFolderNotDone' | translate }}
                </p>
              </div>
            </div>

            <div class="form-field _move-items">
              <div class="_new-added _foldertick2">
                <img src="assets/images/done-folder.svg" [attr.alt]="'doneFolderAlt' | translate" />
              </div>
              <div
                class="form-group custom_radio _box-checkbox toggle_parent"
                appDynamicTabIndex
                tabindex="0"
                (keydown.enter)="setMoveFileToggled('2')"
              >
                <input type="radio" id="status-done" name="status" formControlName="status" value="2" tabindex="-1" />
                <label for="status-done" class="toggle_child"></label>
              </div>
              <div class="_terms">
                <p>
                  {{ 'moveFolderDone.0' | translate }}
                </p>
                <p *ngIf="isExport" class="t-padding">
                  {{ 'moveFolderDone.1' | translate }}
                </p>
              </div>
            </div>

            <div class="form-field _move-items" *ngIf="isExport">
              <div class="_new-added _foldertick2">
                <img src="assets/images/delete-file.svg" [attr.alt]="'trashFolderAlt' | translate" />
              </div>
              <div class="form-group custom_radio toggle_parent" appDynamicTabIndex tabindex="0" (keydown.enter)="setMoveFileToggled('3')">
                <input type="radio" id="status-delete" name="status" formControlName="status" value="3" tabindex="-1" />
                <label for="status-delete" class="toggle_child"></label>
              </div>
              <div class="_terms">
                <p>
                  {{ 'moveFolderTrash' | translate }}
                </p>
              </div>
            </div>
            <!--end-->
            <label class="error" *ngIf="moveFolderForm.controls.status.errors?.required && isSubmitted">
              {{ selectAtLeastone }}
            </label>
          </form>
        </div>
        <div class="_popup-btn">
          <button (click)="toCancel()" class="button" appDynamicTabIndex tabindex="0">
            <div class="d-flex align-items-center">
              <span class="mr-3">{{ 'cancel' | translate }}</span>
              <img class="ml-auto next-arrow mb-n1" src="assets/images/next-arrow.svg" aria-hidden="true" width="13" height="15" />
            </div>
          </button>
          <button (click)="submitStatus()" class="button secondary" appDynamicTabIndex tabindex="0">
            <div class="d-flex align-items-center">
              <span class="mr-3">{{ 'ok' | translate }}</span>
              <img class="ml-auto next-arrow mb-n1" src="assets/images/next-arrow.svg" aria-hidden="true" width="13" height="15" />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
